import React, { useState } from 'react';

import Form from '../../components/ContactForm'
import SendingPage from '../../components/SendingPage';

import { FaGithub } from "react-icons/fa"
import { BsLinkedin } from "react-icons/bs"


function ContactMe({userData}) {

  const [loading, setLoading] = useState(false);

  const getinTouch = userData.getInTouch; // get the getInTouch information from userData

  if(loading){
    return <SendingPage/>
  }

  return (
    <main className='max-w-screen min-h-screen mx3 px-6 xl:px-40 md:px-10'>
      <section className='border-t border-gray-400 flex flex-col xl:flex-row w-full h-full pt-2 sm:pt-12 pb-6 sm:pb-12'>
        <h1 className='heading-font text-2xl xl:text-4xl font-bold max-w-md w-full'>
          Get in Touch
        </h1>
        <div className='w-full h-full'>
          <p className='main-font text-base py-1 sm:py-6 xl:py-0 mb-4 ml-0 xl:ml-14'>
            {getinTouch}
          </p>
          <div className='flex flex-row ml-0 xl:ml-12'>
            <a href="https://github.com/VILLAMORGO" rel="noreferrer" target="_blank">
              <FaGithub className='mr-2 text-3xl'/>
            </a>
            <a href="https://www.linkedin.com/in/villamor-go/" rel="noreferrer" target="_blank">
              <BsLinkedin className='mx-2 text-3xl'/>
            </a>
          </div>
        </div>
      </section>
      <section className='border-t border-gray-400 flex flex-col xl:flex-row w-full h-full py-3 sm:py-12'>
        <h1 className='heading-font text-2xl xl:text-4xl font-bold max-w-md w-full'>
          Contact Me
        </h1>
        <div className='w-full h-full ml-0 xl:ml-14'>
          <Form setLoading={setLoading}/>
        </div>
      </section>
    </main>
  )
}

export default ContactMe;